interface ArtifactEmptyStateProps {
  title: string;
  subtitle?: string;
}

export const ArtifactEmptyState = ({ title, subtitle }: ArtifactEmptyStateProps) => (
  <div className="flex h-full flex-col items-center justify-center gap-2 px-5 text-center">
    <span className="text-2xl text-zinc-700">◫</span>
    <p className="text-[13px] text-zinc-500">{title}</p>
    {subtitle && <p className="text-[11px] text-zinc-600">{subtitle}</p>}
  </div>
);
